import { Progress } from "@maker/design-system/ui/progress";
import { LoaderIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { generateRandomInt } from "../../../../../utils/random";

const TranscriptionsProgress = () => {
	const [value, setValue] = useState(0);

	useEffect(() => {
		window.setTimeout(() => {
			setValue(generateRandomInt([15, 40]));
		}, 500);

		window.setTimeout(() => {
			setValue(generateRandomInt([45, 75]));
		}, 10000);
	}, []);

	return (
		<div className="w-full max-w-40">
			<div className="mb-1">
				<Progress value={value} />
			</div>

			<div className="flex items-center gap-1">
				<LoaderIcon className="animate-spin text-neutral-500" size={12} />

				<div className="font-medium text-sm">Processando...</div>
			</div>
		</div>
	);
};

export { TranscriptionsProgress };
